import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const SignupForm_Box_1 = styled.div`
  margin-top: 16px;
  font-size: 16px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin-top: 24px;
  }
`;

export const SignupForm_Box_2 = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin-top: 40px;
  }
`;

export const SignupForm_Box_3 = styled.div`
  width: 100%;
  padding-inline: 12px;
  flex: 0 0 auto;

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    width: 50%;
  }
`;

export const SignupForm_Box_4 = styled.div`
  width: 100%;
  padding-inline: 12px;
  flex: 0 0 auto;

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    width: 50%;
  }
`;

export const SignupForm_Box_5 = styled.div`
  margin-bottom: 16px;
`;
